<template>
  <div class="shopcart">
    <div class="cart-left" @click.stop = "showDetail">
      <div class="icon-wrap">
        <div class="icon-content" :class="{active:totalCount>0}">
          <span class="icon-shopping_cart"></span>
        </div>
        <div class="count" v-show="totalCount>0">{{totalCount}}</div>
      </div>
      <div class="price-wrap">
        <span class="total-price" :class="{active:totalPrice>0}"><i>¥</i>{{totalPrice}}</span>
      </div>
      <div class="deliveryPrice">
        <span class="text">另需配送费<i> ¥ </i>4元</span>
      </div>
    </div>
    <div class="cart-right" :class="{active:this.totalPrice >= this.minPrice}">
      <span class="text">{{payDesc}}</span>
    </div>
    <transition name="detail-fade">
      <div class="cart-detail" v-show="isShowDetail">
      <div class="header border-1px">
        <span class="title">购物车</span>
        <span class="btn-clear" @click.stop = "clearFoods">清空</span>
      </div>
      <div class="list-wrap" ref="list">
        <ul class="cart-list">
          <li class="food-item" v-for="food in selectFoods">
            <div class="name">
              <span class="text">{{food.name}}</span>
            </div>
            <div class="price-wrap">
              <i>¥</i>{{food.price * food.count}}
            </div>
            <div class="control-wrap">
              <control :food="food"></control>
            </div>
          </li>
        </ul>
      </div>
    </div>
    </transition>
    <transition name="fade">
      <div class="list-mask" @click="hideList" v-show="isShowDetail"></div>
    </transition>
  </div>
</template>

<script type="text/ecmascript-6">
  import BScroll from 'better-scroll';
  import control from 'components/cartcontrol/cartcontrol';
  export default{
    props: {
      minPrice: {
        type: Number,
        default: 20
      },
      deliveryPrice: {
        type: Number,
        default: 4
      },
      selectFoods: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    data() {
      return {
        toggleDetail: false
      };
    },
    computed: {
      totalPrice() {
        let price = 0;
        this.selectFoods.forEach((item) => {
          price += item.price * item.count;
        });
        return price;
      },
      totalCount() {
        let count = 0;
        this.selectFoods.forEach((item) => {
          count += item.count;
        });
        return count;
      },
      payDesc() {
        if (this.totalPrice === 0) {
          return `¥${this.minPrice} 元起送`;
        } else if (this.totalPrice < this.minPrice) {
          let diff = this.minPrice - this.totalPrice;
          return `还差 ¥${diff} 元起送`;
        } else if (this.totalPrice >= this.minPrice) {
          return '去结算';
        }
      },
      isShowDetail() {
        if (this.totalCount === 0) {
          this.toggleDetail = false;
        }
        this.$nextTick(() => {
          this._initScroll();
        });
        return this.toggleDetail;
      }
    },
    components: {
      control
    },
    methods: {
      _initScroll() {
        if (!this.cartScroll) {
          this.cartScroll = new BScroll(this.$refs['list'], {
            click: true,
            probeType: 3
          });
        } else {
          this.cartScroll.refresh();
        }
      },
      showDetail() {
        if (this.totalCount !== 0 && this.toggleDetail === false) {
          this.toggleDetail = true;
        } else {
          this.toggleDetail = false;
        }
      },
      hideList() {
        this.toggleDetail = false;
      },
      clearFoods() {
        this.selectFoods.forEach((item) => {
          item.count = 0;
        });
      }
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  @import "../../common/stylus/mixin.styl";
  .shopcart
    display:flex
    position:fixed
    bottom:0px
    left:0
    z-index:50
    width:100%
    height:48px
    background-color:#141d27
    .cart-left
      flex:1
      display:flex
      background-color:#141d27
      .icon-wrap
        position:relative
        margin:-10px 12px 0px
        padding:6px
        width:56px
        height:56px
        border-radius:50%
        background-color:#141d27
        .icon-content
          width:100%
          height:100%
          text-align:center
          border-radius:50%
          background-color:#2b343c
          .icon-shopping_cart
            font-size:24px
            line-height:44px
            color:rgba(255, 255, 255, 0.4)
        .active
          background-color:#00a0dc
          .icon-shopping_cart
            color:#fff
        .count
          position:absolute
          top:-4px
          left:35px
          padding:4px 8px
          min-width:24px
          font-size:12px
          color:#fff
          text-align:center
          border-radius:10px
          background-color:rgb(240, 20, 20)
          box-shadow:0 4px 8px 0px rgba(0, 0, 0, 0.4)
      .price-wrap
        margin:12px 0
        padding-right:12px
        border-right:1px solid rgba(255, 255, 255, 0.1)
        .total-price
          font-size:16px
          font-weight:700
          line-height:24px
          color:rgba(255, 255, 255, 0.4)
          i
            margin-right:4px
        .active
          color:#fff
      .deliveryPrice
        flex:1
        margin:12px 0
        padding-left:12px
        .text
          font-size:12px
          line-height:24px
          color:rgba(255, 255, 255, 0.4)
    .cart-right
      flex:0 0 105px
      padding:0px 8px
      width:105px
      height:100%
      font-size:12px
      font-weight:700
      line-height:48px
      color:rgba(255, 255, 255, 0.4)
      text-align:center
      background-color:#2b333b
      &.active
        color:#fff
        background-color:#00b43c
    .cart-detail
      position:absolute
      z-index:-1
      left:0
      bottom:48px
      width:100%
      background-color:#fff
      &.detail-fade-enter-active, &.detail-fade-leave-active
        transition:all 0.4s linear
      &.detail-fade-enter, &.detail-fade-leave-active
        transform:translate(0,100%)
      .header
        display:flex
        justify-content:space-between
        padding:0px 18px
        width:100%
        height:40px
        background-color:#f3f5f7
        border-1px(rgba(7, 17, 27, 0.1))
        .title
          font-size:14px
          line-height:40px
          color:rgb(7, 17, 27)
        .btn-clear
          font-size:12px
          line-height:40px
          color:rgb(0, 160, 220)
      .list-wrap
        width:100%
        max-height:218px
        overflow:hidden
        .cart-list
          padding:0 18px
          .food-item
            display:flex
            padding:5px 0
            border-1px(rgba(7, 17, 27, 0.1))
            &:last-child:after
              display:none
            .name
              flex:1
              vertical-align:top
              .text
                font-size:14px
                line-height:34px
                color:rgb(7, 17, 27)
            .price-wrap
              margin:0 6px 0 18px
              vertical-align:top
              font-size:14px
              font-weight:700
              line-height:34px
              color:rgb(240, 20, 20)
              i
                font-size:10px
            .control-wrap
              vertical-align:top
    .list-mask
      position: fixed
      top: 0
      left: 0
      width: 100%
      height: 100%
      z-index: -2
      backdrop-filter: blur(10px)
      opacity: 1
      background: rgba(7, 17, 27, 0.6)
      &.fade-enter-active, &.fade-leave-active
        transition: all 0.5s
      &.fade-enter, &.fade-leave-active
        opacity: 0
        background: rgba(7, 17, 27, 0)
</style>



// WEBPACK FOOTER //
// shopCart.vue?50cef789